import React, { useState } from 'react';

import Salespeople from './Salespeople';
import Students from './Students';

import { SalespeopleAndStudentsContainer } from './styles';

interface IProps {
    isSelect: boolean
}

const SalespeopleAndStudents: React.FC<IProps> = ({ isSelect }) => {
    const [isAdd, setIsAdd] = useState<boolean>(false);

    return (
        <SalespeopleAndStudentsContainer isAdd={isAdd}>
            {isSelect ?
                <Salespeople />
                :
                <Students isAdd={isAdd} setIsAdd={setIsAdd} />
            }
        </SalespeopleAndStudentsContainer>
    )
}

export default SalespeopleAndStudents;
